export default __webpack_public_path__ + "static/media/Foto-16.d72ad404.png";